import { apiRequest } from "@/lib/api-client";

import type { PipelineStage, PipelineStageRun, Source, SourcePipelineStatus } from "./types";

export function importSourceUrl(url: string) {
  return apiRequest<Source>("/sources/import-url", {
    method: "POST",
    body: JSON.stringify({ url })
  });
}

export function listSources() {
  return apiRequest<Source[]>("/sources");
}

export function getSource(sourceId: string) {
  return apiRequest<Source>(`/sources/${sourceId}`);
}

export function listPipelineStatuses() {
  return apiRequest<SourcePipelineStatus[]>("/sources/pipeline-status");
}

export function getSourcePipelineStatus(sourceId: string) {
  return apiRequest<SourcePipelineStatus>(`/sources/${sourceId}/pipeline-status`);
}

export function regenerateSourceClips(sourceId: string) {
  return apiRequest<Source>(`/sources/${sourceId}/regenerate-clips`, {
    method: "POST"
  });
}

export function listPipelineDiagnostics(sourceId: string) {
  return apiRequest<PipelineStageRun[]>(`/sources/${sourceId}/pipeline-diagnostics`);
}

export function retryPipelineStage(sourceId: string, stage: PipelineStage) {
  return apiRequest<{ source_id: string; stage: PipelineStage; queued_jobs: number }>(`/sources/${sourceId}/pipeline/retry`, {
    method: "POST",
    body: JSON.stringify({ stage })
  });
}

export function cancelSourcePipeline(sourceId: string) {
  return apiRequest<{ source_id: string; stopped: string[] }>(`/sources/${sourceId}/pipeline/cancel`, {
    method: "POST"
  });
}

export function deleteSource(sourceId: string) {
  return apiRequest<null>(`/sources/${sourceId}`, { method: "DELETE" });
}
